var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "a-productGrid__item mb-2" +
        [
          _vm.item.herny_produkt_kategoria !== "background"
            ? " --small"
            : " --medium"
        ] +
        [!_vm.item.disabled ? "" : " --soldout"],
      style: "z-index:" + [60 - _vm.index]
    },
    [
      _vm.isPozadie
        ? _c("div", { staticClass: "productGridItem__imgWrap" }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src:
                  "assets/img/produkty/" +
                  _vm.item.herny_produkt_kategoria +
                  "/" +
                  _vm.item.herny_produkt_img_inventar,
                alt: ""
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "productGridItem_content" }, [
        _c("div", { staticClass: "productGridItem__imgWrap" }, [
          !_vm.isPozadie
            ? _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src:
                    "assets/img/produkty/" +
                    _vm.item.herny_produkt_kategoria +
                    "/" +
                    _vm.item.herny_produkt_img_inventar,
                  alt: ""
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "productGridItem_content" }, [
          _c("div", { staticClass: "productGridItem__title" }, [
            _vm._v(_vm._s(_vm.item.herny_produkt_meno))
          ]),
          _vm._v(" "),
          !_vm.item.disabled
            ? _c("div", { staticClass: "productGridItem__price" }, [
                _c("span", { staticClass: "icon" }),
                _vm._v(_vm._s(_vm.item.herny_produkt_cena) + "\n            ")
              ])
            : _c("div", { staticClass: "productGridItem__alreadyBought" }, [
                _vm._v("\n                Zakúpené\n            ")
              ])
        ])
      ]),
      _vm._v(" "),
      !_vm.item.disabled
        ? _c("div", { staticClass: "productGridItem__button" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.$emit("buyProduct", _vm.index, _vm.item)
                  }
                }
              },
              [_c("span", { staticClass: "icon" }), _vm._v("Kúpiť\n        ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.herny_produkt_novinka
        ? _c("span", { staticClass: "productGridItem__new__tag" }, [
            _vm._v("Nové")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }